"use client";

import { useEffect, useRef, useState } from "react";
import { Package, Users, Award } from "lucide-react";

const stats = [
  {
    icon: Package,
    numericValue: 20000,
    prefix: "+",
    suffix: "",
    label: "clients",
    description: "Nos services sont utilisés par des milliers de clients Particuliers et professionnels",
  },
  {
    icon: Users,
    numericValue: 100,
    prefix: "+",
    suffix: "",
    label: "collaborateurs",
    description: "Une équipe dévouée pour vous servir chaque jour",
  },
  {
    icon: Award,
    numericValue: 40,
    prefix: "+",
    suffix: " ans",
    label: "d'expérience",
    description: "Un savoir de qualité acquis avec des années d'expérience",
  },
];

function AnimatedCounter({
  target,
  prefix,
  suffix,
  started,
}: {
  target: number;
  prefix: string;
  suffix: string;
  started: boolean;
}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!started) return;

    const duration = 2000; // 2 secondes
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      // Easing: accélère puis ralentit
      const progress = step / steps;
      const eased = 1 - Math.pow(1 - progress, 3);
      current = Math.round(eased * target);
      setCount(current);

      if (step >= steps) {
        setCount(target);
        clearInterval(timer);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [started, target]);

  const formatted = target >= 1000
    ? count.toLocaleString("fr-FR")
    : String(count);

  return (
    <span>
      {prefix}{formatted}{suffix}
    </span>
  );
}

export function StatsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started]);

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="bg-secondary rounded-3xl py-12 px-6" ref={ref}>
          <div className="grid md:grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center flex flex-col items-center">
                <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center mb-4">
                  <stat.icon className="w-10 h-10 text-secondary" />
                </div>

                <div className="text-2xl md:text-3xl font-bold text-white mb-2">
                  <AnimatedCounter
                    target={stat.numericValue}
                    prefix={stat.prefix}
                    suffix={stat.suffix}
                    started={started}
                  />{" "}
                  {stat.label}
                </div>

                <p className="text-sm text-white/80 max-w-xs">
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
